import {
    arrayUnion,
    collection,
    doc,
    getDocs,
    getFirestore,
    setDoc,
    updateDoc,
} from "firebase/firestore";
import { ProfileKeys, ReportKeys, ReportTypes } from 'fixit-shared/FirestoreKeys';

export const downloadReports = (table, profileId) => {
  return getDocs(
    collection(getFirestore(), `${ProfileKeys.tableName}/${profileId}/${table}`)
  )
  .then(querySnapshot => {
    return querySnapshot.docs.map(docSnapshot => ReportKeys.decompress(docSnapshot));
  });
}

export const saveReport = async (table, report) => {
    // Validated before the try, so that a bad report type is not reported as a
    // failed save. An unrecognised type gives profileKey() null and leaves an
    // undefined path segment, which throws inside the SDK — the catch below
    // then swallowed it and returned false. The profile upload passed a
    // mistyped constant for years and every report it "saved" was discarded
    // in exactly this way, silently.
    const indexKey = ReportTypes.profileKey(table);
    if (!indexKey) {
        throw new Error(`saveReport: unknown report type ${JSON.stringify(table)}`);
    }

    try {
        const db = getFirestore();
        await setDoc(
            doc(db, ProfileKeys.tableName, report.profileId, table, report.id),
            report
        );
        await updateDoc(
            doc(db, ProfileKeys.tableName, report.profileId),
            {
                [indexKey]: arrayUnion(report.id)
            }
        );
        const success = true;
        return success;
    } catch (error) {
        console.error(`Error\n${error}\nwhile adding report:\n${JSON.stringify(report)}`);
        const success = false;
        return success;
    }
}

export const updateReportNotes = async (table, report) => {
    try {
        await updateDoc(
            doc(getFirestore(), ProfileKeys.tableName, report.profileId, table, report.id),
            {notes: report.notes}
        );
        const success = true;
        return success;
    } catch (error) {
        console.error(`Error\n${error}\nwhile updating report:\n${JSON.stringify(report)}`);
        const success = false;
        return success;
    }
}
